/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-04-26 17:36:39
 */

import * as request from '@/utils/request'

export default {
  /**
   * getOpenapiList
   * @description 公司管理列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getOpenapiList(data) {
    return request.post('/openapi/list', data)
  },
  /**
   * saveCategory
   * @description 保存公司
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  saveOpenapi(data) {
    return request.post('/openapi/store', data)
  },
  /**
   * getCategoryInfo
   * @description 获取公司详情
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getOpenapiInfo(id) {
    let data = {id:id}
    return request.post('/openapi/get_info', data)
  },
  /**
   * deleteCategoryInfo
   * @description 删除公司
   * @author YQ
   * @date 2019-01-19
   * @param {*} id
   * @returns
   */
  deleteOpenapi(id) {
    let data = {id:id}
    return request.post('/openapi/delete', data)
  },
  /**
   * @description 分类排序
   * @author YM
   * @date 2019-03-07
   * @param {*} ids
   * @returns
   */
  orderOpenapi(ids) {
    let data = {ids:ids}
    return request.post('/openapi/order',data)
  },
  /**
   * @description 获取公司分类列表
   * @author YM
   * @date 2019-03-04
   * @returns
   */
  getOpenapiCategoryList() {
    return request.post('/openapi/category_list')
  },
}